// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-product-analytics-dashboard__section--attribution {
  gap: 12px;
}
.sales-product-analytics-dashboard__section--attribution .sales-attribution__header-sticky {
  position: sticky;
  top: 0;
  z-index: 8;
  background: #ffffff;
  padding-bottom: 12px;
}
.sales-product-analytics-dashboard__section--attribution .sales-attribution__header-sticky > .dashboard-section-header {
  padding-bottom: 0;
}

.sales-attribution__loading {
  min-height: 320px;
}

.sales-attribution__lens-dropdown-boundary {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 1050;
}
.sales-attribution__lens-dropdown-boundary > * {
  pointer-events: auto;
}

.sales-attribution {
  /* ---------- Filter bar ---------- */
  /* ---------- Dropdown panel ---------- */
  /* ---------- KPIs ---------- */
  /* ---------- Response warnings ---------- */
  /* ---------- Panels ---------- */
  /* ---------- Charts ---------- */
  /* ---------- Series toggles ---------- */
  /* ---------- Pagination ---------- */
  /* ---------- Overlap Venn ---------- */
  /* ---------- Channel scorecard ---------- */
  /* ---------- Channel drilldown ---------- */
  /* ---------- Responsive ---------- */
}
.sales-attribution__main {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
  padding-bottom: 8px;
}
.sales-attribution__header-controls {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  min-width: 0;
}
.sales-attribution__filter-bar-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  min-width: 0;
}
.sales-attribution__header-filters {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  width: 100%;
  min-width: 0;
  padding-top: 4px;
}
.sales-attribution__filter-bar {
  display: grid;
  grid-template-columns: repeat(3, auto);
  column-gap: 5px;
  row-gap: 8px;
  justify-content: end;
  justify-items: end;
  min-width: 0;
}
.sales-attribution__filter-bar-cell {
  grid-column: 1;
  grid-row: 2;
  display: block;
  min-width: 0;
}
.sales-attribution__filter-row-secondary {
  grid-column: 2/4;
  grid-row: 2;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  min-width: 0;
}
.sales-attribution__filter-note {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 4px;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}
.sales-attribution__filter-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  min-width: 0;
}
.sales-attribution__filter-field {
  display: inline-flex;
  flex: 0 0 auto;
}
.sales-attribution__filter-field .ant-select .ant-select-selector,
.sales-attribution__filter-field .custom-dropdown--all-selected .ant-select-selector,
.sales-attribution__filter-field .custom-dropdown--has-value .ant-select-selector {
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  height: auto;
  padding: 4px 2px;
  display: flex;
  align-items: center;
  transition: color 0.15s ease;
}
.sales-attribution__filter-field .ant-select .ant-select-selection-placeholder,
.sales-attribution__filter-field .ant-select .ant-select-selection-item {
  font-size: 13px;
  font-weight: 500;
  color: #5e6a7d;
}
.sales-attribution__filter-field .ant-select-selection-search-input {
  caret-color: transparent;
}
.sales-attribution__filter-field .filter-dropdown .ant-select-selection-item {
  color: #6b7280 !important;
}
.sales-attribution .filter-dropdown-menu {
  padding: 0;
}
.sales-attribution .filter-dropdown-menu .ant-select-item-option {
  position: relative;
  padding: 8px 16px 8px 40px;
  font-size: 13px;
}
.sales-attribution .filter-dropdown-menu .ant-select-item-option::before {
  content: "";
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 1.5px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}
.sales-attribution .filter-dropdown-menu .ant-select-item-option-selected {
  background: transparent;
  font-weight: 500;
}
.sales-attribution .filter-dropdown-menu .ant-select-item-option-selected::before {
  background: #1677ff;
  border-color: #1677ff;
}
.sales-attribution .filter-dropdown-menu .ant-select-item-option-selected::after {
  content: "";
  position: absolute;
  left: 21px;
  top: 47%;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 1.5px 1.5px 0;
  transform: translateY(-60%) rotate(45deg);
}
.sales-attribution .filter-dropdown-menu .ant-select-item-option-active:not(.sales-attribution .filter-dropdown-menu .ant-select-item-option-selected) {
  background: #f5f7fb;
}
.sales-attribution .filter-dropdown-menu .ant-select-item-option .ant-select-item-option-state {
  display: none;
}
.sales-attribution__filter-dropdown-panel {
  display: flex;
  flex-direction: column;
}
.sales-attribution__filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 12px;
  border-top: 1px solid #f0f0f0;
}
.sales-attribution__filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px 4px 10px;
  border-radius: 14px;
  background: #eef4ff;
  color: #1677ff;
  font-size: 12px;
  font-weight: 500;
}
.sales-attribution__filter-chip-remove {
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  line-height: 1;
  font-size: 14px;
  padding: 0;
}
.sales-attribution__filter-chip-remove:hover {
  opacity: 0.7;
}
.sales-attribution .filter-dropdown-menu {
  border-radius: 12px;
  overflow: hidden;
  padding: 0;
}
.sales-attribution__filter-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.sales-attribution__filter-search-icon {
  width: 14px;
  height: 14px;
  border: 1.5px solid #bfbfbf;
  border-radius: 50%;
  position: relative;
  flex: 0 0 auto;
}
.sales-attribution__filter-search-icon::after {
  content: "";
  position: absolute;
  width: 6px;
  height: 1.5px;
  background: #bfbfbf;
  transform: rotate(45deg);
  right: -5px;
  bottom: -1px;
}
.sales-attribution__filter-search-input {
  border: none;
  outline: none;
  font-size: 13px;
  flex: 1 1;
  color: #262626;
  background: transparent;
}
.sales-attribution__filter-search-input::placeholder {
  color: #bfbfbf;
}
.sales-attribution__filter-options {
  max-height: 280px;
  overflow-y: auto;
  padding: 6px;
}
.sales-attribution__filter-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  color: #262626;
}
.sales-attribution__filter-option:hover {
  background: #eef4ff;
}
.sales-attribution__filter-option-checkbox {
  width: 16px;
  height: 16px;
  border: 1.5px solid #d9d9d9;
  border-radius: 4px;
  flex: 0 0 auto;
  background: #fff;
}
.sales-attribution__filter-option--selected .sales-attribution__filter-option-checkbox {
  background: #1677ff;
  border-color: #1677ff;
  position: relative;
}
.sales-attribution__filter-option--selected .sales-attribution__filter-option-checkbox::after {
  content: "";
  position: absolute;
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 1.5px 1.5px 0;
  transform: rotate(45deg);
}
.sales-attribution__filter-option-empty {
  padding: 12px 16px;
  color: #8c8c8c;
  font-size: 13px;
  text-align: center;
}
.sales-attribution__filter-footer {
  padding: 8px 16px;
  border-top: 1px solid #f0f0f0;
}
.sales-attribution__filter-footer-clear {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  font-size: 13px;
  color: #6f6f6f;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}
.sales-attribution__filter-footer-clear:hover {
  color: #242424;
}
.sales-attribution__filter-footer-clear:focus {
  outline: none;
}
.sales-attribution__filter-footer-clear:focus-visible {
  outline: 1px solid #1677ff;
  outline-offset: 2px;
}
.sales-attribution .sales-attribution__filter-bar-clear {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}
.sales-attribution .sales-attribution__filter-bar-clear:hover {
  text-decoration: underline;
}
.sales-attribution .sales-attribution__filter-bar-clear-icon {
  width: 12px;
  height: 12px;
  position: relative;
}
.sales-attribution .sales-attribution__filter-bar-clear-icon::before,
.sales-attribution .sales-attribution__filter-bar-clear-icon::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: currentColor;
}
.sales-attribution .sales-attribution__filter-bar-clear-icon::before {
  transform: rotate(45deg);
}
.sales-attribution .sales-attribution__filter-bar-clear-icon::after {
  transform: rotate(-45deg);
}
.sales-attribution .filter-dropdown .ant-select-selector {
  padding-right: 4px;
  /* was likely larger by default */
}
.sales-attribution .filter-dropdown .ant-select-selection-item {
  padding-right: 2px;
  margin-right: 0;
}
.sales-attribution .sales-attribution__filter-bar .filter-dropdown .ant-select-selection-item {
  padding: 0 !important;
  margin-inline-end: 0 !important;
  background: none !important;
}
.sales-attribution__kpis {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.sales-attribution__kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
.sales-attribution__kpi-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.sales-attribution__kpi-badge {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: none;
  white-space: nowrap;
}
.sales-attribution__warnings {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  border: 1px solid #fcd34d;
  border-radius: 10px;
  background: #fffbeb;
}
.sales-attribution__warning {
  margin: 0;
  color: #92400e;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}
.sales-attribution__invisible-channel {
  padding-top: 16px;
  border-top: 1px solid #e4e8ef;
}
.sales-attribution__invisible-channel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #17325c;
}
.sales-attribution__panel {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e4e8ef;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 74, 151, 0.06);
  overflow: hidden;
}
.sales-attribution__panel-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 18px 12px;
}
.sales-attribution__panel-heading {
  min-width: 0;
}
.sales-attribution__panel-title-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.sales-attribution__panel-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #17325c;
}
.sales-attribution__panel-subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  color: #5e6a7d;
}
.sales-attribution__panel-actions {
  display: flex;
  align-items: center;
  margin-inline-start: auto;
}
.sales-attribution__panel-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.sales-attribution__panel-controls .dashboard-data-table-panel__search,
.sales-attribution__panel-controls .dashboard-data-table-panel__search--small {
  min-width: 0;
  width: 220px;
  height: 42px;
  padding: 0 14px;
  border-radius: 12px;
  border-color: #CCD9F0;
}
.sales-attribution__panel-controls .dashboard-data-table-panel__search input {
  font-size: 13px;
}
.sales-attribution__panel-body {
  padding: 16px 18px 18px;
  min-width: 0;
}
.sales-attribution__empty {
  margin: 0;
  padding: 32px 0;
  text-align: center;
  font-size: 13px;
  color: #5e6a7d;
}
.sales-attribution .recharts-surface {
  direction: ltr;
}
.sales-attribution__chart {
  width: 100%;
  min-width: 0;
}
.sales-attribution__panel:has(.sales-attribution__chart--reconciliation) {
  overflow: visible;
}
.sales-attribution__chart--reconciliation {
  overflow: visible;
}
.sales-attribution__chart--reconciliation .recharts-responsive-container,
.sales-attribution__chart--reconciliation .recharts-wrapper {
  overflow: visible;
}
.sales-attribution__chart--reconciliation .recharts-tooltip-wrapper {
  z-index: 20;
  pointer-events: none;
}
.sales-attribution__chart-tooltip {
  min-width: 180px;
  padding: 10px 12px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(9, 23, 48, 0.24);
  color: #10203a;
  /* Reconciliation has all 14 series active by default, which as a single
     column ran the tooltip off the bottom of the chart. Two columns keeps
     it readable without needing the user to narrow the series first. */
}
.sales-attribution__chart-tooltip--wide {
  min-width: 320px;
}
.sales-attribution__chart-tooltip-title {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
}
.sales-attribution__chart-tooltip-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.sales-attribution__chart-tooltip-list--grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 20px;
}
.sales-attribution__chart-tooltip-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
  line-height: 1.7;
  min-width: 0;
}
.sales-attribution__chart-tooltip-label {
  overflow: hidden;
  color: #94a3b8;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-attribution__chart-tooltip-label--with-dot {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: visible;
  white-space: normal;
}
.sales-attribution__chart-tooltip-label-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-attribution__chart-tooltip-value {
  flex-shrink: 0;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.sales-attribution__series-groups {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}
.sales-attribution__series-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
}
.sales-attribution__series-group-label {
  flex-shrink: 0;
  width: 56px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5e6a7d;
}
.sales-attribution__series-chips {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 6px;
}
.sales-attribution__series-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  background: #f6f8fb;
  border: 1px solid #e4e8ef;
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  color: #5e6a7d;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.sales-attribution__series-chip:hover {
  border-color: rgba(43, 116, 228, 0.45);
  color: #17325c;
}
.sales-attribution__series-chip:focus-visible {
  outline: 2px solid #2b74e4;
  outline-offset: 2px;
}
.sales-attribution__series-chip--active {
  background: rgba(43, 116, 228, 0.1);
  border-color: #2b74e4;
  font-weight: 600;
  color: #2b74e4;
}
.sales-attribution__series-chip-dot {
  width: 7px;
  height: 7px;
  flex-shrink: 0;
  border-radius: 50%;
}
.sales-attribution__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 12px;
}
.sales-attribution__pagination-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sales-attribution__pagination-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #ffffff;
  border: 1px solid #e4e8ef;
  border-radius: 6px;
  color: #5e6a7d;
  cursor: pointer;
}
.sales-attribution__pagination-button:hover:not(:disabled) {
  border-color: #2b74e4;
  color: #2b74e4;
}
.sales-attribution__pagination-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.sales-attribution__pagination-button:focus-visible {
  outline: 2px solid #2b74e4;
  outline-offset: 2px;
}
.sales-attribution__pagination-label {
  font-size: 12px;
  color: #5e6a7d;
  font-variant-numeric: tabular-nums;
}
.sales-attribution__venn-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}
.sales-attribution__venn {
  position: relative;
  margin: 0;
  min-width: 0;
  padding: 16px;
  border: 1px solid #e4e8ef;
  border-radius: 12px;
  background: #f6f8fb;
}
.sales-attribution__venn-title {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 600;
  color: #17325c;
}
.sales-attribution__venn-svg {
  display: block;
  width: 100%;
  max-width: 320px;
  height: auto;
  margin: 0 auto;
}
.sales-attribution__venn-shape {
  cursor: help;
  transition: fill-opacity 0.15s ease;
}
.sales-attribution__venn-value {
  font-size: 10.5px;
  font-weight: 600;
  fill: #17325c;
  cursor: help;
}
.sales-attribution__venn-value--overlap {
  font-size: 11.5px;
  font-weight: 700;
}
.sales-attribution__venn-share {
  font-size: 11px;
  fill: #5e6a7d;
}
.sales-attribution__venn-tooltip {
  position: absolute;
  left: 50%;
  bottom: 56px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  width: max-content;
  max-width: calc(100% - 24px);
  padding: 8px 12px;
  border: 1px solid #e4e8ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(23, 50, 92, 0.12);
  font-size: 12px;
  color: #5e6a7d;
  pointer-events: none;
  z-index: 2;
}
.sales-attribution__venn-tooltip-label {
  font-weight: 700;
  color: #17325c;
  white-space: nowrap;
}
.sales-attribution__venn-legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 4px;
  font-size: 11px;
  color: #5e6a7d;
}
.sales-attribution__venn-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: default;
}
.sales-attribution__venn-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.sales-attribution__scorecard.dashboard-data-table {
  border-collapse: separate;
  border-spacing: 8px 10px;
}
.sales-attribution__scorecard.dashboard-data-table th {
  padding: 4px 12px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #5e6a7d;
  background: #ffffff;
  border-bottom: none;
}
.sales-attribution__scorecard.dashboard-data-table td {
  padding: 12px;
  font-size: 12.5px;
  font-weight: 500;
  background: transparent;
  border-top: none;
  border-bottom: none;
}
.sales-attribution__scorecard.dashboard-data-table tbody td,
.sales-attribution__scorecard.dashboard-data-table tfoot td {
  border-top: none;
  border-bottom: none;
}
.sales-attribution__scorecard.dashboard-data-table tbody td:first-child,
.sales-attribution__scorecard.dashboard-data-table tfoot td:first-child {
  padding-inline-start: 0;
  font-size: 13px;
  font-weight: 500;
  color: #17325c;
  white-space: nowrap;
}
.sales-attribution__scorecard.dashboard-data-table tfoot td:first-child {
  font-weight: 600;
}
.sales-attribution__scorecard.dashboard-data-table tfoot td.sales-attribution__scorecard-total-cell {
  background: rgba(43, 116, 228, 0.06) !important;
}
.sales-attribution__scorecard-row {
  cursor: pointer;
}
.sales-attribution__scorecard-row:hover td {
  filter: brightness(0.97);
}
.sales-attribution__scorecard-row:focus-visible {
  outline: 2px solid #2b74e4;
  outline-offset: 2px;
}
.sales-attribution__scorecard-divider td {
  height: 1px;
  padding: 0;
  background: #e4e8ef;
}
.sales-attribution__scorecard-cell {
  font-variant-numeric: tabular-nums;
  border-radius: 10px;
}
.sales-attribution__scorecard-total-cell {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.sales-attribution__scorecard-scale {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
  font-size: 11px;
  color: #5e6a7d;
}
.sales-attribution__scorecard-scale-bar {
  width: 96px;
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(to right, rgba(43, 116, 228, 0.12), rgb(43, 116, 228));
}
.sales-attribution__drilldown-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #5e6a7d;
  cursor: pointer;
}
.sales-attribution__drilldown-close:hover {
  background: #f6f8fb;
  color: #17325c;
}
.sales-attribution__drilldown-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.sales-attribution__drilldown-subtitle {
  margin: 0;
  font-size: 12px;
  color: #5e6a7d;
}
.sales-attribution__drilldown-kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.sales-attribution__drilldown-stat {
  border: 1px solid #e4e8ef;
  background: #f6f8fb;
  border-radius: 8px;
  padding: 10px;
}
.sales-attribution__drilldown-stat-label {
  margin: 0;
  font-size: 11px;
  color: #5e6a7d;
}
.sales-attribution__drilldown-stat-value {
  margin: 2px 0 0;
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #17325c;
}
.sales-attribution__drilldown-chart {
  margin-top: 4px;
}
.sales-attribution__visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}
@media (max-width: 1280px) {
  .sales-attribution__kpi-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 992px) {
  .sales-attribution__kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sales-attribution__venn-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 640px) {
  .sales-attribution {
    width: 100%;
  }
  .sales-attribution__kpi-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .sales-attribution__header-filters {
    align-items: flex-start;
  }
  .sales-attribution__filter-bar {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }
  .sales-attribution__filter-row-secondary {
    justify-content: flex-start;
    width: 100%;
  }
  .sales-attribution__filter-bar-cell {
    display: none;
  }
  .sales-attribution__filter-row {
    justify-content: flex-start;
  }
  .sales-attribution__filter-note {
    white-space: normal;
  }
  .sales-attribution__panel-header {
    flex-direction: column;
    align-items: stretch;
  }
  .sales-attribution__panel-actions {
    margin-inline-start: 0;
  }
  .sales-attribution__panel-body {
    padding: 14px 12px 16px;
  }
}

.tippy-box.sales-attribution__series-chip-tooltip[data-theme~=dt] {
  background-color: #ffffff;
  color: #5e6a7d;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.4;
  padding: 10px 12px;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(9, 23, 48, 0.24);
}
.tippy-box.sales-attribution__series-chip-tooltip[data-theme~=dt] .tippy-arrow {
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/dashboards/salesProductAnalytics/components/SalesProductAttributionSection.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AASA;EACE,SAAA;AARF;AAUE;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;AARJ;AAUI;EACE,iBAAA;AARN;;AAaA;EACE,iBAAA;AAVF;;AAaA;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;AAVF;AAYE;EACE,oBAAA;AAVJ;;AAcA;EASE,qCAAA;EAsHA,yCAAA;EAkSA,+BAAA;EAmCA,4CAAA;EAqCA,iCAAA;EAoFA,iCAAA;EAqGA,yCAAA;EAyEA,qCAAA;EAmDA,uCAAA;EA0GA,4CAAA;EAsGA,4CAAA;EA2EA,qCAAA;AAxjCF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;AAEJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAHJ;AAME;EACE,aAAA;EACA,sCAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;AAJJ;AAOE;EACE,cAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AALJ;AAQE;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,YAAA;AANJ;AASE;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,YAAA;AARJ;AAWE;EACE,oBAAA;EACA,cAAA;AATJ;AAWI;;;EAGE,kCAAA;EACA,uBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;AATN;AAYI;;EAEE,eAAA;EACA,gBAAA;EACA,cArJoB;AA2I1B;AAiBI;EACE,wBAAA;AAfN;AAmBM;EACE,yBAAA;AAjBR;AAwBE;EACE,UAAA;AAtBJ;AAwBI;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;AAtBN;AAyBM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAvBR;AA0BM;EACE,uBAAA;EACA,gBAAA;AAxBR;AA0BQ;EACE,mBAAA;EACA,qBAAA;AAxBV;AA4BQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,yCAAA;AA1BV;AA8BM;EACE,mBAAA;AA5BR;AA+BM;EACE,aAAA;AA7BR;AAkCE;EACE,aAAA;EACA,sBAAA;AAhCJ;AAmCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;AAjCJ;AAoCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAlCJ;AAqCE;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AAnCJ;AAqCI;EACE,YAAA;AAnCN;AAuCE;EACE,mBAAA;EACA,gBAAA;EACA,UAAA;AArCJ;AAwCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;AAtCJ;AAyCE;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAvCJ;AAyCI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;AAvCN;AA2CE;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,uBAAA;AAzCJ;AA2CI;EACE,cAAA;AAzCN;AA6CE;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AA5CJ;AA8CI;EACE,mBAAA;AA5CN;AA+CI;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AA7CN;AAiDE;EACE,mBAAA;EACA,qBAAA;EACA,kBAAA;AA/CJ;AAiDI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,wBAAA;AA/CN;AAmDE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAjDJ;AAoDE;EACE,iBAAA;EACA,6BAAA;AAlDJ;AAqDE;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAnDJ;AAqDI;EACE,cAAA;AAnDN;AAuDI;EACE,aAAA;AArDN;AAwDI;EACE,0BAAA;EACA,mBAAA;AAtDN;AA4DE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA1DJ;AA6DE;EACE,0BAAA;AA3DJ;AA8DE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA5DJ;AA+DE;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;AA7DJ;AAgEE;EACE,wBAAA;AA9DJ;AAiEE;EACE,yBAAA;AA/DJ;AAkEE;EACE,kBAAA;EACA,iCAAA;AAhEJ;AAmEE;EACE,kBAAA;EACA,eAAA;AAjEJ;AAoEE;EACE,qBAAA;EACA,+BAAA;EACA,2BAAA;AAlEJ;AAuEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArEJ;AAwEE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAtEJ;AAyEE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAvEJ;AA0EE;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;AAxEJ;AA6EE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AA3EJ;AA8EE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA5EJ;AA+EE;EACE,iBAAA;EACA,6BAAA;AA7EJ;AAgFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cA/gBqB;AAiczB;AAmFE;EACE,aAAA;EACA,sBAAA;EACA,mBAphBwB;EAqhBxB,yBAAA;EACA,mBAAA;EACA,6CAAA;EACA,gBAAA;AAjFJ;AAoFE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;AAlFJ;AAqFE;EACE,YAAA;AAnFJ;AAsFE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AApFJ;AAuFE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cArjBqB;AAgezB;AAwFE;EACE,eAAA;EACA,eAAA;EACA,cA1jBsB;AAoe1B;AAyFE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAvFJ;AA0FE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AAxFJ;AA0FI;;EAEE,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,qBCvjBY;AD+dlB;AA2FI;EACE,eAAA;AAzFN;AA6FE;EACE,uBAAA;EACA,YAAA;AA3FJ;AA8FE;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAlmBsB;AAsgB1B;AAiGE;EACE,cAAA;AA/FJ;AAkGE;EACE,WAAA;EACA,YAAA;AAhGJ;AAmGE;EACE,iBAAA;AAjGJ;AAoGE;EACE,iBAAA;AAlGJ;AAoGI;;EAEE,iBAAA;AAlGN;AAqGI;EACE,WAAA;EACA,oBAAA;AAnGN;AAuGE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,cAAA;EAEA;;uEAAA;AApGJ;AAuGI;EACE,gBAAA;AArGN;AAyGE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAvGJ;AA0GE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AAxGJ;AA0GI;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;AAxGN;AA4GE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AA1GJ;AA6GE;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AA3GJ;AA6GI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AA3GN;AA+GE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA7GJ;AAgHE;EACE,cAAA;EACA,gBAAA;EACA,kCAAA;AA9GJ;AAmHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAjHJ;AAoHE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;AAlHJ;AAqHE;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAluBsB;AA+mB1B;AAsHE;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;AApHJ;AAuHE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBA9uB8B;EA+uB9B,yBAAA;EACA,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAtvBsB;EAuvBtB,eAAA;EACA,4EAAA;AArHJ;AAuHI;EACE,sCAAA;EACA,cA7vBmB;AAwoBzB;AAwHI;EACE,0BAAA;EACA,mBAAA;AAtHN;AAyHI;EACE,mCAAA;EACA,qBAlwBqB;EAmwBrB,gBAAA;EACA,cApwBqB;AA6oB3B;AA2HE;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAzHJ;AA+HE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AA7HJ;AAgIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA9HJ;AAiIE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAxyBwB;EAyyBxB,yBAAA;EACA,kBAAA;EACA,cA7yBsB;EA8yBtB,eAAA;AA/HJ;AAiII;EACE,qBA7yBqB;EA8yBrB,cA9yBqB;AA+qB3B;AAkII;EACE,aAAA;EACA,mBAAA;AAhIN;AAmII;EACE,0BAAA;EACA,mBAAA;AAjIN;AAqIE;EACE,eAAA;EACA,cAl0BsB;EAm0BtB,kCAAA;AAnIJ;AAwIE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAtIJ;AAyIE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAl1B8B;AA2sBlC;AA0IE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cA71BqB;AAqtBzB;AA2IE;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAzIJ;AA4IE;EACE,YAAA;EACA,mCAAA;AA1IJ;AA6IE;EACE,iBAAA;EACA,gBAAA;EACA,aAh3BqB;EAi3BrB,YAAA;AA3IJ;AA6II;EACE,iBAAA;EACA,gBAAA;AA3IN;AA+IE;EACE,eAAA;EACA,aA13BsB;AA6uB1B;AAgJE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,4BAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAx4BwB;EAy4BxB,6CAAA;EACA,eAAA;EACA,cA74BsB;EA84BtB,oBAAA;EACA,UAAA;AA9IJ;AAiJE;EACE,gBAAA;EACA,cAr5BqB;EAs5BrB,mBAAA;AA/IJ;AAkJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,cA/5BsB;AA+wB1B;AAmJE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAjJJ;AAoJE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAlJJ;AAuJE;EAEE,yBAAA;EACA,wBAAA;AAtJJ;AAwJI;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cA37BoB;EA47BpB,mBA17BsB;EA27BtB,mBAAA;AAtJN;AAyJI;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAvJN;AA0JI;;EAEE,gBAAA;EACA,mBAAA;AAxJN;AA4JI;;EAEE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAt9BmB;EAu9BnB,mBAAA;AA1JN;AA6JI;EACE,gBAAA;AA3JN;AAgKI;EACE,+CAAA;AA9JN;AAkKE;EACE,eAAA;AAhKJ;AAkKI;EACE,wBAAA;AAhKN;AAmKI;EACE,0BAAA;EACA,mBAAA;AAjKN;AAqKE;EACE,WAAA;EACA,UAAA;EACA,mBAn/BuB;AAg1B3B;AAsKE;EACE,kCAAA;EACA,mBAAA;AApKJ;AAuKE;EACE,gBAAA;EACA,kCAAA;AArKJ;AAwKE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,cAxgCsB;AAk2B1B;AAyKE;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,kFAAA;AAvKJ;AAgLE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAjiCsB;EAkiCtB,eAAA;AA9KJ;AAgLI;EACE,mBAliC4B;EAmiC5B,cAviCmB;AAy3BzB;AAkLE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhLJ;AAmLE;EACE,SAAA;EACA,eAAA;EACA,cAnjCsB;AAk4B1B;AAoLE;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAlLJ;AAqLE;EACE,yBAAA;EACA,mBA3jC8B;EA4jC9B,kBAAA;EACA,aAAA;AAnLJ;AAsLE;EACE,SAAA;EACA,eAAA;EACA,cAtkCsB;AAk5B1B;AAuLE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cA/kCqB;AA05BzB;AAwLE;EACE,eAAA;AAtLJ;AAyLE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAvLJ;AA4LE;EACE;IACE,gDAAA;EA1LJ;AACF;AA6LE;EACE;IACE,gDAAA;EA3LJ;EA8LE;IACE,qCAAA;EA5LJ;AACF;AA+LE;EA3kCF;IA4kCI,WAAA;EA5LF;EA8LE;IACE,qCAAA;EA5LJ;EA+LE;IACE,uBAAA;EA7LJ;EAgME;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,WAAA;EA9LJ;EAiME;IACE,2BAAA;IACA,WAAA;EA/LJ;EAkME;IACE,aAAA;EAhMJ;EAmME;IACE,2BAAA;EAjMJ;EAoME;IACE,mBAAA;EAlMJ;EAqME;IACE,sBAAA;IACA,oBAAA;EAnMJ;EAsME;IACE,sBAAA;EApMJ;EAuME;IACE,uBAAA;EArMJ;AACF;;AA0MA;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;AAvMF;AAyME;EACE,cAAA;AAvMJ","sourcesContent":["@import \"../../../styles/variables\";\n\n$sales-attribution-text: #17325c;\n$sales-attribution-muted: #5e6a7d;\n$sales-attribution-border: #e4e8ef;\n$sales-attribution-surface: #ffffff;\n$sales-attribution-surface-muted: #f6f8fb;\n$sales-attribution-accent: #2b74e4;\n\n.sales-product-analytics-dashboard__section--attribution {\n  gap: 12px;\n\n  .sales-attribution__header-sticky {\n    position: sticky;\n    top: 0;\n    z-index: 8;\n    background: #ffffff;\n    padding-bottom: 12px;\n\n    > .dashboard-section-header {\n      padding-bottom: 0;\n    }\n  }\n}\n\n.sales-attribution__loading {\n  min-height: 320px;\n}\n\n.sales-attribution__lens-dropdown-boundary {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 1050;\n\n  > * {\n    pointer-events: auto;\n  }\n}\n\n.sales-attribution {\n  &__main {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    min-width: 0;\n    padding-bottom: 8px;\n  }\n\n  /* ---------- Filter bar ---------- */\n\n  &__header-controls {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 8px;\n    width: 100%;\n    min-width: 0;\n  }\n\n  &__filter-bar-wrap {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    width: 100%;\n    min-width: 0;\n  }\n\n  &__header-filters {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 6px;\n    width: 100%;\n    min-width: 0;\n    padding-top: 4px;\n  }\n\n  &__filter-bar {\n    display: grid;\n    grid-template-columns: repeat(3, auto);\n    column-gap: 5px;\n    row-gap: 8px;\n    justify-content: end;\n    justify-items: end;\n    min-width: 0;\n  }\n\n  &__filter-bar-cell {\n    grid-column: 1;\n    grid-row: 2;\n    display: block;\n    min-width: 0;\n  }\n\n  &__filter-row-secondary {\n    grid-column: 2 / 4;\n    grid-row: 2;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 5px;\n    min-width: 0;\n  }\n\n  &__filter-note {\n    display: inline-flex;\n    align-items: center;\n    flex: 0 0 auto;\n    gap: 4px;\n    color: #64748b;\n    font-size: 11px;\n    font-weight: 500;\n    white-space: nowrap;\n  }\n\n  &__filter-row {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 5px;\n    min-width: 0;\n  }\n\n  &__filter-field {\n    display: inline-flex;\n    flex: 0 0 auto;\n\n    .ant-select .ant-select-selector,\n    .custom-dropdown--all-selected .ant-select-selector,\n    .custom-dropdown--has-value .ant-select-selector {\n      background: transparent !important;\n      border: none !important;\n      border-radius: 0 !important;\n      height: auto;\n      padding: 4px 2px;\n      display: flex;\n      align-items: center;\n      transition: color 0.15s ease;\n    }\n\n    .ant-select .ant-select-selection-placeholder,\n    .ant-select .ant-select-selection-item {\n      font-size: 13px;\n      font-weight: 500;\n      color: $sales-attribution-muted;\n    }\n\n    // `showSearch` renders a real text `<input>` inside the trigger for typing\n    // a filter query. With the pill's opaque background gone, its blinking\n    // text-insertion caret now shows against the page — hide just the caret,\n    // typing to filter still works.\n    .ant-select-selection-search-input {\n      caret-color: transparent;\n    }\n\n    .filter-dropdown {\n      .ant-select-selection-item {\n        color: #6b7280 !important;\n      }\n    }\n  }\n\n  /* ---------- Dropdown panel ---------- */\n\n  .filter-dropdown-menu {\n    padding: 0;\n\n    .ant-select-item-option {\n      position: relative;\n      padding: 8px 16px 8px 40px;\n      font-size: 13px;\n\n      // Checkbox square\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 16px;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 16px;\n        height: 16px;\n        border: 1.5px solid #d9d9d9;\n        border-radius: 4px;\n        background: #fff;\n        box-sizing: border-box;\n      }\n\n      &-selected {\n        background: transparent;\n        font-weight: 500;\n\n        &::before {\n          background: #1677ff;\n          border-color: #1677ff;\n        }\n\n        // Checkmark\n        &::after {\n          content: \"\";\n          position: absolute;\n          left: 21px;\n          top: 47%;\n          width: 4px;\n          height: 8px;\n          border: solid #fff;\n          border-width: 0 1.5px 1.5px 0;\n          transform: translateY(-60%) rotate(45deg);\n        }\n      }\n\n      &-active:not(&-selected) {\n        background: #f5f7fb;\n      }\n\n      .ant-select-item-option-state {\n        display: none;\n      }\n    }\n  }\n\n  &__filter-dropdown-panel {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__filter-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    padding: 10px 12px;\n    border-top: 1px solid #f0f0f0;\n  }\n\n  &__filter-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 8px 4px 10px;\n    border-radius: 14px;\n    background: #eef4ff;\n    color: #1677ff;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  &__filter-chip-remove {\n    border: none;\n    background: transparent;\n    color: inherit;\n    cursor: pointer;\n    line-height: 1;\n    font-size: 14px;\n    padding: 0;\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  .filter-dropdown-menu {\n    border-radius: 12px;\n    overflow: hidden;\n    padding: 0;\n  }\n\n  &__filter-search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    border-bottom: 1px solid #f0f0f0;\n  }\n\n  &__filter-search-icon {\n    width: 14px;\n    height: 14px;\n    border: 1.5px solid #bfbfbf;\n    border-radius: 50%;\n    position: relative;\n    flex: 0 0 auto;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      width: 6px;\n      height: 1.5px;\n      background: #bfbfbf;\n      transform: rotate(45deg);\n      right: -5px;\n      bottom: -1px;\n    }\n  }\n\n  &__filter-search-input {\n    border: none;\n    outline: none;\n    font-size: 13px;\n    flex: 1;\n    color: #262626;\n    background: transparent;\n\n    &::placeholder {\n      color: #bfbfbf;\n    }\n  }\n\n  &__filter-options {\n    max-height: 280px;\n    overflow-y: auto;\n    padding: 6px;\n  }\n\n  &__filter-option {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 10px;\n    border-radius: 10px;\n    cursor: pointer;\n    font-size: 13px;\n    color: #262626;\n\n    &:hover {\n      background: #eef4ff;\n    }\n\n    &-checkbox {\n      width: 16px;\n      height: 16px;\n      border: 1.5px solid #d9d9d9;\n      border-radius: 4px;\n      flex: 0 0 auto;\n      background: #fff;\n    }\n  }\n\n  &__filter-option--selected .sales-attribution__filter-option-checkbox {\n    background: #1677ff;\n    border-color: #1677ff;\n    position: relative;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      left: 5px;\n      top: 2px;\n      width: 4px;\n      height: 8px;\n      border: solid #fff;\n      border-width: 0 1.5px 1.5px 0;\n      transform: rotate(45deg);\n    }\n  }\n\n  &__filter-option-empty {\n    padding: 12px 16px;\n    color: #8c8c8c;\n    font-size: 13px;\n    text-align: center;\n  }\n\n  &__filter-footer {\n    padding: 8px 16px;\n    border-top: 1px solid #f0f0f0;\n  }\n\n  &__filter-footer-clear {\n    border: none;\n    background: none;\n    padding: 0;\n    margin: 0;\n    font-size: 13px;\n    color: #6f6f6f;\n    cursor: pointer;\n    text-align: left;\n    font-family: inherit;\n\n    &:hover {\n      color: #242424;\n    }\n\n    // strip default button focus box (that's the outline around \"Clear\" in image 1)\n    &:focus {\n      outline: none;\n    }\n\n    &:focus-visible {\n      outline: 1px solid #1677ff;\n      outline-offset: 2px;\n    }\n  }\n\n  // Sits inline after the last chip in its row — no `margin-left: auto`, which\n  // would shove it away from the right-aligned group it belongs to.\n  .sales-attribution__filter-bar-clear {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px 6px;\n    font-size: 13px;\n    font-weight: 500;\n    white-space: nowrap;\n  }\n\n  .sales-attribution__filter-bar-clear:hover {\n    text-decoration: underline;\n  }\n\n  .sales-attribution__filter-bar-clear-icon {\n    width: 12px;\n    height: 12px;\n    position: relative;\n  }\n\n  .sales-attribution__filter-bar-clear-icon::before,\n  .sales-attribution__filter-bar-clear-icon::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: currentColor;\n  }\n\n  .sales-attribution__filter-bar-clear-icon::before {\n    transform: rotate(45deg);\n  }\n\n  .sales-attribution__filter-bar-clear-icon::after {\n    transform: rotate(-45deg);\n  }\n\n  .filter-dropdown .ant-select-selector {\n    padding-right: 4px;\n    /* was likely larger by default */\n  }\n\n  .filter-dropdown .ant-select-selection-item {\n    padding-right: 2px;\n    margin-right: 0;\n  }\n\n  .sales-attribution__filter-bar .filter-dropdown .ant-select-selection-item {\n    padding: 0 !important;\n    margin-inline-end: 0 !important;\n    background: none !important;\n  }\n\n  /* ---------- KPIs ---------- */\n\n  &__kpis {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n  }\n\n  &__kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 14px;\n  }\n\n  &__kpi-title {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n\n  &__kpi-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 1px 6px;\n    border-radius: 999px;\n    background: #f1f5f9;\n    color: #64748b;\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    text-transform: none;\n    white-space: nowrap;\n  }\n\n  /* ---------- Response warnings ---------- */\n\n  &__warnings {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 10px 12px;\n    border: 1px solid #fcd34d;\n    border-radius: 10px;\n    background: #fffbeb;\n  }\n\n  &__warning {\n    margin: 0;\n    color: #92400e;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.5;\n  }\n\n  &__invisible-channel {\n    padding-top: 16px;\n    border-top: 1px solid $sales-attribution-border;\n  }\n\n  &__invisible-channel-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0 0 12px;\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: $sales-attribution-text;\n  }\n\n  /* ---------- Panels ---------- */\n\n  &__panel {\n    display: flex;\n    flex-direction: column;\n    background: $sales-attribution-surface;\n    border: 1px solid $sales-attribution-border;\n    border-radius: 12px;\n    box-shadow: 0 1px 2px rgb(15 74 151 / 6%);\n    overflow: hidden;\n  }\n\n  &__panel-header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 20px 18px 12px;\n  }\n\n  &__panel-heading {\n    min-width: 0;\n  }\n\n  &__panel-title-row {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  &__panel-title {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: $sales-attribution-text;\n  }\n\n  &__panel-subtitle {\n    margin: 4px 0 0;\n    font-size: 12px;\n    color: $sales-attribution-muted;\n  }\n\n  &__panel-actions {\n    display: flex;\n    align-items: center;\n    margin-inline-start: auto;\n  }\n\n  &__panel-controls {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n\n    .dashboard-data-table-panel__search,\n    .dashboard-data-table-panel__search--small {\n      min-width: 0;\n      width: 220px;\n      height: 42px;\n      padding: 0 14px;\n      border-radius: 12px;\n      border-color: $border-dropdown;\n    }\n\n    .dashboard-data-table-panel__search input {\n      font-size: 13px;\n    }\n  }\n\n  &__panel-body {\n    padding: 16px 18px 18px;\n    min-width: 0;\n  }\n\n  &__empty {\n    margin: 0;\n    padding: 32px 0;\n    text-align: center;\n    font-size: 13px;\n    color: $sales-attribution-muted;\n  }\n\n  /* ---------- Charts ---------- */\n\n  .recharts-surface {\n    direction: ltr;\n  }\n\n  &__chart {\n    width: 100%;\n    min-width: 0;\n  }\n\n  &__panel:has(&__chart--reconciliation) {\n    overflow: visible;\n  }\n\n  &__chart--reconciliation {\n    overflow: visible;\n\n    .recharts-responsive-container,\n    .recharts-wrapper {\n      overflow: visible;\n    }\n\n    .recharts-tooltip-wrapper {\n      z-index: 20;\n      pointer-events: none;\n    }\n  }\n\n  &__chart-tooltip {\n    min-width: 180px;\n    padding: 10px 12px;\n    background: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 6px 18px rgb(9 23 48 / 24%);\n    color: #10203a;\n\n    /* Reconciliation has all 14 series active by default, which as a single\n       column ran the tooltip off the bottom of the chart. Two columns keeps\n       it readable without needing the user to narrow the series first. */\n    &--wide {\n      min-width: 320px;\n    }\n  }\n\n  &__chart-tooltip-title {\n    margin: 0 0 6px;\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  &__chart-tooltip-list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    &--grid {\n      display: grid;\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n      column-gap: 20px;\n    }\n  }\n\n  &__chart-tooltip-row {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 10px;\n    font-size: 12px;\n    line-height: 1.7;\n    min-width: 0;\n  }\n\n  &__chart-tooltip-label {\n    overflow: hidden;\n    color: #94a3b8;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &--with-dot {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      min-width: 0;\n      overflow: visible;\n      white-space: normal;\n    }\n  }\n\n  &__chart-tooltip-label-text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__chart-tooltip-value {\n    flex-shrink: 0;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n  }\n\n  /* ---------- Series toggles ---------- */\n\n  &__series-groups {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 16px;\n  }\n\n  &__series-group {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    min-width: 0;\n  }\n\n  &__series-group-label {\n    flex-shrink: 0;\n    width: 56px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: $sales-attribution-muted;\n  }\n\n  &__series-chips {\n    display: flex;\n    flex: 1 1 auto;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  &__series-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 11px;\n    background: $sales-attribution-surface-muted;\n    border: 1px solid $sales-attribution-border;\n    border-radius: 999px;\n    font-family: inherit;\n    font-size: 12px;\n    color: $sales-attribution-muted;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n    &:hover {\n      border-color: rgb(43 116 228 / 45%);\n      color: $sales-attribution-text;\n    }\n\n    &:focus-visible {\n      outline: 2px solid $sales-attribution-accent;\n      outline-offset: 2px;\n    }\n\n    &--active {\n      background: rgb(43 116 228 / 10%);\n      border-color: $sales-attribution-accent;\n      font-weight: 600;\n      color: $sales-attribution-accent;\n    }\n  }\n\n  &__series-chip-dot {\n    width: 7px;\n    height: 7px;\n    flex-shrink: 0;\n    border-radius: 50%;\n  }\n\n  /* ---------- Pagination ---------- */\n\n  // Page label pinned left, arrows pinned right.\n  &__pagination {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    margin-top: 12px;\n  }\n\n  &__pagination-buttons {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__pagination-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    background: $sales-attribution-surface;\n    border: 1px solid $sales-attribution-border;\n    border-radius: 6px;\n    color: $sales-attribution-muted;\n    cursor: pointer;\n\n    &:hover:not(:disabled) {\n      border-color: $sales-attribution-accent;\n      color: $sales-attribution-accent;\n    }\n\n    &:disabled {\n      opacity: 0.45;\n      cursor: not-allowed;\n    }\n\n    &:focus-visible {\n      outline: 2px solid $sales-attribution-accent;\n      outline-offset: 2px;\n    }\n  }\n\n  &__pagination-label {\n    font-size: 12px;\n    color: $sales-attribution-muted;\n    font-variant-numeric: tabular-nums;\n  }\n\n  /* ---------- Overlap Venn ---------- */\n\n  &__venn-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 18px;\n  }\n\n  &__venn {\n    position: relative;\n    margin: 0;\n    min-width: 0;\n    padding: 16px;\n    border: 1px solid $sales-attribution-border;\n    border-radius: 12px;\n    background: $sales-attribution-surface-muted;\n  }\n\n  &__venn-title {\n    margin: 0 0 4px;\n    font-size: 13px;\n    font-weight: 600;\n    color: $sales-attribution-text;\n  }\n\n  &__venn-svg {\n    display: block;\n    width: 100%;\n    max-width: 320px;\n    height: auto;\n    margin: 0 auto;\n  }\n\n  &__venn-shape {\n    cursor: help;\n    transition: fill-opacity 0.15s ease;\n  }\n\n  &__venn-value {\n    font-size: 10.5px;\n    font-weight: 600;\n    fill: $sales-attribution-text;\n    cursor: help;\n\n    &--overlap {\n      font-size: 11.5px;\n      font-weight: 700;\n    }\n  }\n\n  &__venn-share {\n    font-size: 11px;\n    fill: $sales-attribution-muted;\n  }\n\n  &__venn-tooltip {\n    position: absolute;\n    left: 50%;\n    bottom: 56px;\n    transform: translateX(-50%);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: max-content;\n    max-width: calc(100% - 24px);\n    padding: 8px 12px;\n    border: 1px solid $sales-attribution-border;\n    border-radius: 8px;\n    background: $sales-attribution-surface;\n    box-shadow: 0 8px 20px rgb(23 50 92 / 12%);\n    font-size: 12px;\n    color: $sales-attribution-muted;\n    pointer-events: none;\n    z-index: 2;\n  }\n\n  &__venn-tooltip-label {\n    font-weight: 700;\n    color: $sales-attribution-text;\n    white-space: nowrap;\n  }\n\n  &__venn-legend {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 12px;\n    margin-top: 4px;\n    font-size: 11px;\n    color: $sales-attribution-muted;\n  }\n\n  &__venn-legend-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    cursor: default;\n  }\n\n  &__venn-legend-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n  }\n\n  /* ---------- Channel scorecard ---------- */\n\n  &__scorecard.dashboard-data-table {\n\n    border-collapse: separate;\n    border-spacing: 8px 10px;\n\n    th {\n      padding: 4px 12px 14px;\n      font-size: 13px;\n      font-weight: 600;\n      color: $sales-attribution-muted;\n      background: $sales-attribution-surface;\n      border-bottom: none;\n    }\n\n    td {\n      padding: 12px;\n      font-size: 12.5px;\n      font-weight: 500;\n      background: transparent;\n      border-top: none;\n      border-bottom: none;\n    }\n\n    tbody td,\n    tfoot td {\n      border-top: none;\n      border-bottom: none;\n    }\n\n    // Row label column stays a plain label: no chip, no bold.\n    tbody td:first-child,\n    tfoot td:first-child {\n      padding-inline-start: 0;\n      font-size: 13px;\n      font-weight: 500;\n      color: $sales-attribution-text;\n      white-space: nowrap;\n    }\n\n    tfoot td:first-child {\n      font-weight: 600;\n    }\n\n    // Beats DashboardDataTable.scss's `.dashboard-data-table td { background: #ffffff }`\n    // (1 class + 1 type) — needs 2 classes + 1 type here to win outright.\n    tfoot td.sales-attribution__scorecard-total-cell {\n      background: rgb(43 116 228 / 6%) !important;\n    }\n  }\n\n  &__scorecard-row {\n    cursor: pointer;\n\n    &:hover td {\n      filter: brightness(0.97);\n    }\n\n    &:focus-visible {\n      outline: 2px solid $sales-attribution-accent;\n      outline-offset: 2px;\n    }\n  }\n\n  &__scorecard-divider td {\n    height: 1px;\n    padding: 0;\n    background: $sales-attribution-border;\n  }\n\n  &__scorecard-cell {\n    font-variant-numeric: tabular-nums;\n    border-radius: 10px;\n  }\n\n  &__scorecard-total-cell {\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__scorecard-scale {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 10px;\n    font-size: 11px;\n    color: $sales-attribution-muted;\n  }\n\n  &__scorecard-scale-bar {\n    width: 96px;\n    height: 8px;\n    border-radius: 999px;\n    background: linear-gradient(\n      to right,\n      rgb(43 116 228 / 12%),\n      rgb(43 116 228 / 100%)\n    );\n  }\n\n  /* ---------- Channel drilldown ---------- */\n\n  &__drilldown-close {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border: none;\n    border-radius: 6px;\n    background: transparent;\n    color: $sales-attribution-muted;\n    cursor: pointer;\n\n    &:hover {\n      background: $sales-attribution-surface-muted;\n      color: $sales-attribution-text;\n    }\n  }\n\n  &__drilldown-body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__drilldown-subtitle {\n    margin: 0;\n    font-size: 12px;\n    color: $sales-attribution-muted;\n  }\n\n  &__drilldown-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  &__drilldown-stat {\n    border: 1px solid $sales-attribution-border;\n    background: $sales-attribution-surface-muted;\n    border-radius: 8px;\n    padding: 10px;\n  }\n\n  &__drilldown-stat-label {\n    margin: 0;\n    font-size: 11px;\n    color: $sales-attribution-muted;\n  }\n\n  &__drilldown-stat-value {\n    margin: 2px 0 0;\n    font-size: 16px;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    color: $sales-attribution-text;\n  }\n\n  &__drilldown-chart {\n    margin-top: 4px;\n  }\n\n  &__visually-hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  /* ---------- Responsive ---------- */\n\n  @media (max-width: 1280px) {\n    &__kpi-grid {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n  }\n\n  @media (max-width: 992px) {\n    &__kpi-grid {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    &__venn-grid {\n      grid-template-columns: minmax(0, 1fr);\n    }\n  }\n\n  @media (max-width: 640px) {\n    width: 100%;\n\n    &__kpi-grid {\n      grid-template-columns: minmax(0, 1fr);\n    }\n\n    &__header-filters {\n      align-items: flex-start;\n    }\n\n    &__filter-bar {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n      width: 100%;\n    }\n\n    &__filter-row-secondary {\n      justify-content: flex-start;\n      width: 100%;\n    }\n\n    &__filter-bar-cell {\n      display: none;\n    }\n\n    &__filter-row {\n      justify-content: flex-start;\n    }\n\n    &__filter-note {\n      white-space: normal;\n    }\n\n    &__panel-header {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    &__panel-actions {\n      margin-inline-start: 0;\n    }\n\n    &__panel-body {\n      padding: 14px 12px 16px;\n    }\n  }\n}\n\n// Reconciliation chip tooltips render in a Tippy portal — match chart tooltip styling.\n.tippy-box.sales-attribution__series-chip-tooltip[data-theme~=\"dt\"] {\n  background-color: #ffffff;\n  color: #5e6a7d;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.4;\n  padding: 10px 12px;\n  border-radius: 8px;\n  box-shadow: 0 6px 18px rgb(9 23 48 / 24%);\n\n  .tippy-arrow {\n    color: #ffffff;\n  }\n}","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
